export default {
	data() {
		return {
			pageSize: 10,
			pages: [],
			busys: [],
			finishs: [],
			typeIndex: -1,
			typeList: [],
			pageData: [],
			keyword: '',
			contentId: '',
			isAuto: true,
			userId: '',
			curPage: 1,
			pageTotal: [],
			stateList: [],
			stateIndex: 0,
			isConcat: false,
			searchTitle: ''
		}
	},
	computed: {
		curData_() {
			return this.pageData[this.typeIndex] || [];
		},
		finish_() {
			return this.finishs[this.typeIndex] || false;
		},
		busy_() {
			return this.busys[this.typeIndex] || false;
		},
		page_() {
			return this.pages[this.typeIndex] || 1;
		},
		channelId_() {
			return (this.typeList[this.typeIndex] || {}).value || ''
		},
		activityStatus_() {
			return (this.stateList[this.stateIndex] || {}).value || ''
		},
		pageTotal_() {
			return this.pageTotal[this.typeIndex] || 0;
		},
	},
	watch: {
		curPage(val) {
			if(val < this.page_){
				this.$set(this.busys, this.typeIndex, false);
			}
			this.changeType(this.typeIndex, val);
		}
	},
	created() {
		this.init();
	},
	methods: {
		init(isAuto = false) {
			let query = this.$route.query;
			let params = this.$route.params;
			params.contentId && (this.contentId = params.contentId);
			query.keyword && (this.keyword = query.keyword);
			query.userId && (this.userId = query.userId);
			this.userId ==='' &&(this.userId = params.userId)
			if(query.title){
				uni.setNavigationBarTitle({
					title: query.title
				})
			}
			if(!this.isAuto && !isAuto) return ;
			let len = this.typeList.length || 1;
			let slen = this.stateList.length;
			let arrFillFalse = Array(len).fill(false);
			let arrFill0 = Array(len).fill(0);
			let arrFill1 = Array(len).fill(1);
			this.pages = [...arrFill1];
			this.busys = [...arrFillFalse];
			this.finishs = [...arrFillFalse];
			this.pageTotal = [...arrFill0];
			this.changeType(0, 1, isAuto);
		},
		changeState(e = 0) {
			this.stateIndex = e;
			this.changeType(this.typeIndex, 1, true);
		},
		changeType(e = 0, page = 1, isAuto) {
			if(this.typeIndex === e && page === this.page_ && !this.searchTitle && !isAuto) return ;
			this.curPage = page;
			this.$set(this.pages, e, page);
			if(page === 1){
				this.$set(this.busys, e, false);
				this.$set(this.pageTotal, e, 0);
			}
			this.typeIndex = e;
			let routeName = this.routeName || this.$route.name;
			switch (routeName){
				case 'aboutIntro':
				case 'aboutSurvey':
				case 'culturalCloudFront':
				case 'contact':
				case 'userAgreement':
				case 'volunteerHomeIntro':
				case 'volunteerHomeJoinUs':
				case 'volunteerHomeEnroll':
					this.getFirstOfChannelPath();
					break;
				case 'behEncore':
				this.encorePage();
					break;
				case 'comment':
					this.getCommentLatest();
					break;
				case 'culturalActivity':
					this.getActivityPage();
					break;
				case 'circlesList':
					this.getCulturalPage();
					break;
				case 'culturalMapDetail':
					if(e === 0){
						this.getResourceDetail && this.getResourceDetail();
					}else{
						this.getSubSitePage();
					}
					break;
				case 'collection':
					this.myCollection();
					break;
				case 'circlesFollow':
					this.followPage();
					break;
				case 'circlesFans':
					this.fansPage();
					break;
				case 'circlesDetail':
					this.userCultralPage();
					break;
				case 'signInList':
					this.signInRecord();
					break;
				case 'myCircles':
					this.myCultralPage();
					break;
				case 'systemMessage':
					this.getInbox();
					break;
				case 'privateLetter':
					this.memberTalkPage();
					break;
				case 'privateLetterDetail':
					this.memberTalkDetailsPage();
					break;
				case 'settingCollection':
					this.collectionPage();
					break;
				case 'settingActivity':
					this.activityPage();
					break;
				case 'settingNotice':
					this.sysMsgPage();
					break;
				case 'signIn':
					this.scoreDetails();
					break;
				case 'interaction':
					this.interactionPage();
					break;
				case 'volunteerHomeProject':
					this.getActivityPage();
				default:
					this.resourcePage();
					break;
			}
			// if(routeName === 'aboutIntro' || routeName === 'aboutSurvey' || routeName === 'culturalCloudFront' || routeName === 'contact'){
			// 	this.getFirstOfChannelPath();
			// }else if(routeName === 'volunteerHomeIntro' || routeName === 'volunteerHomeJoinUs'){
			// 	this.getFirstOfChannelPath();
			// }else if(routeName === 'behEncore'){
			// 	this.encorePage();
			// }else if(routeName === 'comment'){
			// 	this.getCommentLatest();
			// }else if(routeName === 'culturalActivity'){
			// 	this.getActivityPage();
			// }else if(routeName === 'circlesList'){
			// 	this.getCulturalPage();
			// }else if(routeName === 'culturalMapDetail'){
			// 	if(e === 0){
			// 		this.getResourceDetail && this.getResourceDetail();
			// 	}else{
			// 		this.getSubSitePage();
			// 	}
			// }else if(routeName === 'settingCollection'){
			// 	this.collectionPage()
			// }else if(routeName === 'follow'){
			// 	this.followPage();
			// }else if(routeName === 'fans'){
			// 	this.fansPage();
			// }else if(routeName === 'circlesDetail'){
			// 	this.userCultralPage();
			// }else if(routeName === 'signInList'){
			// 	this.signInRecord();
			// }else if(routeName === 'myCircles'){
			// 	this.myCultralPage();
			// }else if(routeName === 'systemMessage'){
			// 	this.getInbox();
			// }else if(routeName === 'privateLetter'){
			// 	this.memberTalkPage();
			// }else if(routeName === 'privateMessageRecord'){
			// 	this.memberTalkDetailsPage();
			// }else if(routeName === 'collection') {
			// 	this.myCollection();
			// }else if(routeName === 'settingNotice'){
			// 	this.sysMsgPage();
			// }else{
			// 	this.resourcePage();
			// }
		},
		async interactionPage(){
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('interactionPage', params);
			this.setData(res, typeIndex,);
		},
		async scoreDetails(){
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('scoreDetails', params);
			this.setData(res, typeIndex,);
		},
		async sysMsgPage(){
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('sysMsgPage', params);
			this.setData(res, typeIndex,);
		},
		// 圈子收藏列表
		async myCollection() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize,
				channelId: this.channelId_
			}
			let res = await this.$http('myCollection', params);
			let content = [];
			res.data.content && res.data.content.length && (content = res.data.content.map(o => o = o.content));
			res.data.content = content;
			this.setData(res, typeIndex,);
		},
		// 私聊记录
		async memberTalkDetailsPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize,
				talkUserId: this.userId
			}
			let res = await this.$http('memberTalkDetailsPage', params);
			this.setData(res, typeIndex,);
		},
		// 私信消息列表
		async memberTalkPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('memberTalkPage', params);
			this.setData(res, typeIndex,);
		},
		// 系统私信收件箱
		async getInbox() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('inbox', params);
			this.setData(res, typeIndex,);
		},
		//签到记录
		async myCultralPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize,
				channelId: this.channelId_
			}
			let res = await this.$http('myCultralPage', params);
			let content = [];
			res.data.content && res.data.content.length && (content = res.data.content.map(o => o = o.content));
			res.data.content = content;
			this.setData(res, typeIndex,);
		},
		//签到记录
		async signInRecord() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('signInRecord', params);
			this.setData(res, typeIndex,);
		},
		//用户圈子列表
		async userCultralPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				userId: this.userId,
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('userCultralPage', params);
			let content = [];
			res.data.content && res.data.content.length && (content = res.data.content.map(o => o = o.content));
			res.data.content = content;
			this.setData(res, typeIndex);
		},
		// 粉丝列表
		async fansPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('fansPage', params);
			this.setData(res, typeIndex);
		},
		//关注列表
		async followPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				userId: this.userId,
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http(params.userId ? 'userFollowPage' : 'followPage', params);
			this.setData(res, typeIndex);
		},
		//收藏列表
		async collectionPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				title: this.searchTitle,
				page: this.page_,
				size: this.pageSize,
				type: 0
			}
			let res = await this.$http('collectionPage', params);
			this.setData(res, typeIndex, params.title);
		},
		//报名列表
		async activityPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				title: this.searchTitle,
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('myActivityPage', params);
			this.setData(res, typeIndex, params.title);
		},
		//本馆文化资讯, 本馆风采展示
		async getSubSitePage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				siteName: this.articleData.title,
				channelPaths: this.channelId_,
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http(typeIndex === 2 ? 'subSitePage' : 'subSiteActivityPage', params);
			this.setData(res, typeIndex, params.title);
		},
		// 评论列表
		async getCommentLatest() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				contentId: this.contentId,
				page: this.page_,
				size: this.pageSize
			}
			let res = await this.$http('commentLatest', params);
			this.setData(res, typeIndex, params.title);
		},
		// 精彩返场
		async encorePage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				size: this.pageSize,
				page: this.page_,
				status: this.channelId_
			}
			let res = await this.$http('encorePage', params)
			this.setData(res, typeIndex);
		},
		// 圈子列表
		async getCulturalPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				size: this.pageSize,
				page: this.page_,
				channelId: this.channelId_,
				searchContent: this.searchTitle
			}
			let res = await this.$http('culturalPage', params);
			let content = [];
			res.data.content && res.data.content.length && (content = res.data.content.map(o => o = o.content));
			res.data.content = content;
			this.setData(res, typeIndex, params.title);
		},
		// 普通文章
		async resourcePage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				size: this.pageSize,
				page: this.page_
			}
			if(this.typeList && this.typeList.length){
				params.channelPaths = this.channelId_;
			}else{
				if(!this.keyword) return ;
				params.title = this.keyword;
			}
			let res = await this.$http('resourcePage', params)
			this.setData(res, typeIndex, params.title);
		},
		// 获取第一篇文章
		async getFirstOfChannelPath() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				channelPaths: this.channelId_,
			}
			let res = await this.$http('firstOfChannelPath', params)
			this.setData(res, typeIndex);
		},
		// 活动列表
		async getActivityPage() {
			let typeIndex = this.typeIndex;
			if(this.requireBefore(typeIndex)) return ;
			let params = {
				channelPaths: this.channelId_,
				activityStatus: this.activityStatus_,
				size: this.pageSize,
				page: this.page_
			}
			let res = await this.$http('activityPage', params);
			this.setData(res, typeIndex);
		},
		requireBefore(typeIndex = 0) {
			if(this.busy_) return true;
			this.$set(this.busys, typeIndex, true);
			this.$set(this.finishs, typeIndex, false);
			this.page_ === 1 && this.$set(this.pageData, typeIndex, []);
			return false;
		},
		setData(res, typeIndex, title) {
			let pageData = this.$deepClone(this.pageData);
			if(res.code === 1){
				let { content, last = false, totalElements = 0 } = res.data || {};
				this.pageTotal_ !== totalElements && this.$set(this.pageTotal, typeIndex, totalElements);
				this.busy_ !== last && this.$set(this.busys, typeIndex, last);
				if(this.$typeof(content) === 'Array'){
					if(this.isConcat){
						pageData[typeIndex] = pageData[typeIndex].concat(content);
					}else{
						pageData[typeIndex] = content;
					}
				}else{
					pageData[typeIndex] = res.data;
				}
				if(title){
					let searchStorage = this.$local.get('searchStorage') || [];
					searchStorage.push(title);
					this.$local.set('searchStorage', Array.from(new Set(searchStorage)));
				}
			}
			this.$set(this.finishs, typeIndex, true);
			this.pageData = pageData;
		}
	}
}
